import {
  Box,
  Flex,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Grid,
  GridItem,
  Spinner,
} from "@chakra-ui/react";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSentInvitation } from "../../../Redux/App/action";
import { IoIosAddCircle } from "react-icons/io";

const Invitations = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedObject, setSelectedObject] = useState(null);
  const dispatch = useDispatch();
  const { sentInvitationsCards, isLoading } = useSelector(
    (store) => store.appReducer,
  );
  const [invitationDetail, setInvitationDetail] = useState(false);
  useEffect(() => {
    dispatch(getSentInvitation);
  }, []);

  const [size, setSize] = React.useState("full");

  const handleSizeClick = (newSize) => {
    setSize(newSize);
    onOpen();
  };

  const sizes = ["xs", "sm", "md", "lg", "xl", "full"];
  const handleCardClick = (el) => {
    setSelectedObject(el);
    onOpen();
  };
  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <>
      <Tabs p={2}>
        <TabList mb="1em">
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 0 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={18}
            >
              Invitation Sent <IoIosAddCircle size={20} color="green" />
            </Flex>
          </Tab>
          <Tab w={"50%"} borderRadius={14}>
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 0 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={{ md: 18, base: 16 }}
            >
              Invitation Receive
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Box display="flex" flexWrap="wrap">
              {sentInvitationsCards &&
                sentInvitationsCards.map((el, i) => (
                  <Flex
                    key={i}
                    flexBasis="30%"
                    flexGrow={0}
                    flexShrink={0}
                    p={2}
                  >
                    <Box
                      cursor="pointer"
                      onClick={() => handleCardClick(el)}
                      borderRadius={10}
                    >
                      <Image
                        src={el.customizedInvitationImg}
                        w="100%"
                        h="auto"
                        borderRadius={10}
                      />
                      <Text
                        cursor="pointer"
                        fontWeight="bold"
                        color="blue"
                        mt={2}
                        textAlign="center"
                      >
                        View Details
                      </Text>
                    </Box>
                  </Flex>
                ))}
            </Box>

            <Modal isOpen={isOpen} onClose={onClose} size={size}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  {selectedObject && (
                    <>
                      <Box margin={"auto"} width={"50%"}>
                        <Image
                          margin={"auto"}
                          src={selectedObject.customizedInvitationImg}
                          w="30%"
                          h="auto"
                          borderRadius={10}
                        />
                      </Box>
                      <Grid mt={"4"} templateColumns="repeat(5, 1fr)" gap={6}>
                        {selectedObject.senderDataList.map((sender, index) => (
                          <Box key={index}>
                            <GridItem
                              border={"1px"}
                              p={"2"}
                              borderRadius={"10"}
                              boxShadow="rgba(1, 5, 5, 0.2) 5px 5px 3px 0px"
                            >
                              <Text
                                fontWeight="semibold"
                                fontSize={{ md: 14, base: 12 }}
                              >
                                Invitation Status:{" "}
                                <span style={{ color: "#FC1A64" }}>
                                  {sender.invitationStatus}
                                </span>
                              </Text>
                              <Text
                                fontWeight="semibold"
                                fontSize={{ md: 14, base: 12 }}
                              >
                                Guest Name:{" "}
                                <span style={{ color: "green" }}>
                                  {sender.guestName}
                                </span>
                              </Text>
                              <Text
                                fontWeight="semibold"
                                fontSize={{ md: 14, base: 12 }}
                              >
                                Guest Note:{" "}
                                <span style={{ color: "green" }}>
                                  {sender.guestNote}
                                </span>
                              </Text>
                              <Text
                                fontWeight="semibold"
                                fontSize={{ md: 14, base: 12 }}
                              >
                                No. Of Guest:{" "}
                                <span style={{ color: "green" }}>
                                  {sender.noOfGuestComming}
                                </span>
                              </Text>
                            </GridItem>
                          </Box>
                        ))}
                      </Grid>
                    </>
                  )}
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme="blue" mr={3} onClick={onClose}>
                    Close
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </TabPanel>
          <TabPanel>
            <Box
              display={"grid"}
              gridTemplateColumns={{
                md: "repeat(2,1fr)",
                base: "repeat(1,1fr)",
              }}
              gap={4}
            >
              {sentInvitationsCards &&
                sentInvitationsCards.map((el, i) => (
                  <Box key={i}>
                    {el.senderDataList &&
                      el.senderDataList.map((ele, index) => (
                        <Flex
                          borderRadius={10}
                          gap={{ md: 2, base: 0 }}
                          textAlign={"left"}
                          flexDirection={{ base: "column", md: "row" }}
                          boxShadow={
                            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
                          }
                          key={index}
                        >
                          <Image
                            src={ele.img}
                            w={{ md: "10%", base: "50%" }}
                            borderRadius={10}
                            m={{ base: "auto" }}
                            h={{ base: 200, md: "65px" }}
                          />
                          <Box w={{ md: "44%", base: "90%" }} px={5} py={2}>
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{ md: 14, base: 12 }}
                            >
                              Invitation Status:{" "}
                              <span style={{ color: "#FC1A64" }}>
                                {ele.invitationStatus}
                              </span>
                            </Text>
                            <Text
                              mt={2}
                              fontWeight={"semibold"}
                              fontSize={{ md: 14, base: 12 }}
                            >
                              Guest Name:{" "}
                              <span style={{ color: "green" }}>
                                {ele.guestName}
                              </span>
                            </Text>
                          </Box>
                          <Flex
                            w={"44%"}
                            px={5}
                            py={2}
                            flexDirection={{ md: "column", base: "row" }}
                            gap={{ md: 0, base: "24%" }}
                          >
                            <Text
                              fontWeight={"semibold"}
                              fontSize={{ md: 14, base: 12 }}
                            >
                              {ele.guestPhoneNumber}
                            </Text>
                            <Text
                              mt={{ md: 2, base: 0 }}
                              fontWeight={"semibold"}
                              fontSize={{ md: 14, base: 12 }}
                              color={"#1492E6"}
                            >
                              {ele.guestEmail}
                            </Text>
                          </Flex>
                        </Flex>
                      ))}
                  </Box>
                ))}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default Invitations;
